import React, {Component} from 'react';
import PropTypes from "prop-types";
import Accordion from '../../components/accordion';

/**
 * SubNavigationLower
 */
class SubNavigationLower extends Component {
  static propTypes = {
    pcTitle: PropTypes.string,
    mbTitle: PropTypes.string,
    carsTitle: PropTypes.bool,
    rootLink: PropTypes.shape({
      pageName: PropTypes.string,
      pcText: PropTypes.string,
      mbText: PropTypes.string,
      href: PropTypes.string,
      external: PropTypes.bool,
    }),
    estimationHistory: PropTypes.arrayOf(PropTypes.node),
    links: PropTypes.arrayOf(PropTypes.shape({
      pageName: PropTypes.string,
      pcText: PropTypes.string,
      mbText: PropTypes.string,
      href: PropTypes.string,
      external: PropTypes.bool,
      nestedNavigation: PropTypes.object,
    })),
    hierarchy: PropTypes.number,
  };
  static defaultProps = {
    pcTitle: null,
    mbTitle: null,
    carsTitle: null,
    rootLink: null,
    estimationHistory: null,
    links: null,
    hierarchy: 0,
  };
  
  constructor(props) {
    super();
    this.props = props;
  }
  
  //
  render() {
    if (this.props.hierarchy <= 1) return null;
    // リンク情報取得
    let links = this.getLinks(this.props.links);
    // HTML出力
    if (links !== null && 1 <= links.length) {
      return (
        <div className="SubNavigation__lower">
          <ul className="SubNavigation__list-ul">
            {links.map((link, index) => {
              return (
                <li key={index}>
                  <SubNavigationLink
                    pageName={link.pageName}
                    pcText={link.pcText}
                    mbText={link.mbText}
                    href={link.href}
                    external={link.external}
                    current={link.current}
                  />
                </li>
              )
            })}
          </ul>
        </div>
      )
    } else {
      return null
    }
  }
  
  getLinks = (links = null) => {
    if (links === null) return null;
    let i, max;
    for (i = 0, max = links.length; i < max; i = i + 1) {
      if (links[i].current === true) {
        if (links[i].nestedNavigation !== null && links[i].nestedNavigation.links !== null && 1 <= links[i].nestedNavigation.links.length) {
          let flg = false;
          let j, max2;
          for (j = 0, max2 = links[i].nestedNavigation.links.length; j < max2; j = j + 1) {
            if (links[i].nestedNavigation.links[j].current === true) {
              flg = true;
            }
          }
          if (!flg) {
            return links;
          } else {
            return this.getLinks(links[i].nestedNavigation.links);
          }
        }
      }
    }
    return links
  }
  
}

export default SubNavigationLower;

/**
 * SubNavigationLink
 */
const SubNavigationLink = ({
                             pageName,
                             pcText,
                             mbText,
                             href,
                             external,
                             current,
                           }) => {
  
  //
  const getPcText = () => {
    if (pcText && pcText !== '') {
      return pcText;
    } else {
      return pageName;
    }
  };
  
  //
  const getMbText = () => {
    if (mbText && mbText !== '') {
      return mbText;
    } else if (pcText && pcText !== '') {
      return pcText;
    } else {
      return pageName;
    }
  };
  
  //
  return (
    <a className={'SubNavigation__link' + ((current === true) ? ' current': '')}
       href={href}
       target={(external === true) ? '_blank': ''}
    >
      <span>
        <span className="SubNavigation__link-pc">{getPcText().replace('|', '')}</span>
        <span className="SubNavigation__link-mb">{getMbText().replace('|', '')}</span>
        <span className="SubNavigation__link-border"/>
      </span>
    </a>
  )
};



// WEBPACK FOOTER //
// ./src/containers/sub-navigation/lower.jsx